import { createFocusTrap } from 'focus-trap';
import isFunction from 'lodash/isFunction.js';
import { keyCodes } from './utils.js';

var FocusTrap = {
  name: 'FocusTrap',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    escapeDeactivates: {
      type: Boolean,
      default: false
    },
    returnFocusOnDeactivate: {
      type: Boolean,
      default: true
    },
    allowOutsideClick: {
      type: [Boolean, Function],
      default: true
    },
    clickOutsideDeactivates: {
      type: Boolean,
      default: true
    },
    initialFocus: {
      type: [String, Function],
      default: undefined
    },
    fallbackFocus: {
      type: [String, Function]
    },
    preventScroll: {
      type: Boolean,
      default: false
    },
    delayInitialFocus: {
      type: Boolean,
      default: true
    },
    tabbableOptions: {
      type: Object,
      default: () => ({})
    },
    isKeyForward: {
      type: Function,
      default: event => event.keyCode === keyCodes.tab && !event.shiftKey
    },
    isKeyBackward: {
      type: Function,
      default: event => event.keyCode === keyCodes.tab && event.shiftKey
    }
  },
  model: {
    event: 'update:active',
    prop: 'active'
  },
  watch: {
    active: {
      handler(active) {
        if (active) {
          this.trap = createFocusTrap(this.$el, {
            escapeDeactivates: this.escapeDeactivates,
            allowOutsideClick: event => isFunction(this.allowOutsideClick) ? this.allowOutsideClick(event) : this.allowOutsideClick,
            clickOutsideDeactivates: this.clickOutsideDeactivates,
            returnFocusOnDeactivate: this.returnFocusOnDeactivate,
            onActivate: () => {
              this.$emit('update:active', true);
              this.$emit('activate');
            },
            onPostActivate: () => {
              this.$emit('activated');
            },
            onDeactivate: () => {
              this.$emit('update:active', false);
              this.$emit('deactivate');
            },
            onPostDeactivate: () => {
              this.$emit('deactivated');
            },
            initialFocus: this.initialFocus,
            fallbackFocus: this.fallbackFocus || (() => this.$el)
          });
          this.trap.activate();
        } else if (this.trap) {
          this.trap.deactivate();
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.trap) {
      this.trap.deactivate();
    }
    this.trap = null;
  },
  methods: {
    activate() {
      this.trap.activate();
    },
    deactivate() {
      this.trap.deactivate();
    }
  },
  render() {
    return this.$scopedSlots.default(this);
  }
};

export { FocusTrap as default };
//# sourceMappingURL=focus-trap.js.map
